import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router} from 'react-router-dom'
import store from './store';
import {Provider} from 'react-redux'

import './styles/main.css'
import AnimatedRoutes from './AnimatedRoutes';
// import {DarkModeProvider} from './components/modoDark/DarkModeContext';
// import FloatingDarkMode from './components/modoDark/Floating.DarkMode';

// import './styles/Darkmode.css'

import ButtonWhatsapp from './components/buttonWhatsapp/ButtonWhatsapp';

function App() {
  return (
    // <DarkModeProvider>
    <Provider store={store}>
      <Router>
        <AnimatedRoutes/>
      </Router>
      {/* <FloatingDarkMode/> */}
      <ButtonWhatsapp/>
    </Provider>
    // </DarkModeProvider>
  );
}

export default App;
